<template>
<div class="content">
  <div class="header">
    <h1>{{ pageTitle }}</h1>
  </div>
  <div class="content-body table-wrapper">
    <div class="block">
      <Table :loading="loading" highlight-row :data="partMigraeteHistory" :columns="columns" stripe border>
        <template slot-scope="{ row, column, index }" slot="compareCell">
          <div v-if="_.get(row, column.key) !== undefined && _.trim(_.get(row, column.key)) != _.trim(_.get(row, column.compare))">
            <div class="current">{{_.get(row, column.key)}}</div>
            <div class="original">ⓘ {{_.get(row, column.compare)}}</div>
          </div>
          <div v-else>{{_.get(row, column.key)}}</div>
        </template>
        <template slot-scope="{ row, column, index }" slot="rateCompareCell">
          <div v-if="_.get(row, column.compare) !== undefined && _.get(row, column.key) != _.get(row, column.compare)">
            <div class="original">{{_.get(row, column.key) * 100}}</div>
            <div class="compare">ⓘ {{_.get(row, column.compare) * 100}}</div>
          </div>
          <div v-else>{{_.get(row, column.key) * 100}}</div>
        </template>
        <template slot-scope="{ row, column, index }" slot="booleanCompareCell">
          <div v-if="_.get(row, column.key) != _.get(row, column.compare)">
            <div class="original">{{_.get(row, column.key) ? 'Yes' : 'No'}}</div>
            <div class="compare">ⓘ {{_.get(row, column.compare) ? 'Yes' : 'No'}}</div>
          </div>
          <div v-else>{{_.get(row, column.key) ? 'Yes' : 'No'}}</div>
        </template>
        <template slot-scope="{ row, column, index }" slot="numberCompareCell">
          <div v-if="parseFloat(_.get(row, column.key)) != parseFloat(_.get(row, column.compare))">
            <div class="current">{{_.get(row, column.key)}}</div>
            <div class="original">ⓘ {{_.get(row, column.compare)}}</div>
          </div>
          <div v-else>{{_.get(row, column.key)}}</div>
        </template>
      </Table>
    </div>
  </div>
</div>
</template>

<style lang="less" scoped>
.current {
  color: #333;
}
.original {
  color: orangered;
}
</style>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'PartOverview',
  data () {
    return {
      loading: false,
      partId: +this.$route.query.partId,
      partMigrateHistory: [],
      columns: [
        {
          type: 'index',
          width: 50,
          align: 'center',
          fixed: 'left'
        },
        {
          key: 'data.ProdID',
          title: 'Part Number',
          align: 'left',
          minWidth: 110,
          fixed: 'left',
          compare: 'origin_data.ProdID',
          slot: 'compareCell'
        },
        {
          key: 'data.ClassExId',
          title: 'Part Class',
          align: 'left',
          minWidth: 80,
          fixed: 'left',
          compare: 'origin_data.ClassExId',
          slot: 'compareCell'
        },
        {
          key: 'data.ProdName',
          title: 'Part Name',
          align: 'left',
          minWidth: 100,
          fixed: 'left',
          compare: 'origin_data.ProdName',
          slot: 'compareCell'
        },
        {
          key: 'data.ProdSize',
          title: 'MPN',
          align: 'left',
          minWidth: 120,
          fixed: 'left',
          compare: 'origin_data.ProdSize',
          slot: 'compareCell'
        },
        {
          key: 'data.EngName',
          title: 'English Name',
          align: 'left',
          minWidth: 110,
          compare: 'origin_data.EngName',
          slot: 'compareCell'
        },
        {
          key: 'data.StdUnitID',
          title: 'Unit ID',
          align: 'left',
          minWidth: 70,
          compare: 'origin_data.StdUnitID',
          slot: 'compareCell'
        },
        {
          key: 'data.Unit',
          title: 'Unit Name',
          align: 'left',
          minWidth: 85,
          compare: 'origin_data.Unit',
          slot: 'compareCell'
        },
        {
          key: 'data.ProdDesc',
          title: 'Description',
          align: 'left',
          minWidth: 140,
          compare: 'origin_data.ProdDesc',
          slot: 'compareCell'
        },
        {
          key: 'data.ProdForm',
          title: 'Part Type',
          align: 'left',
          minWidth: 100,
          compare: 'origin_data.ProdForm',
          slot: 'compareCell'
        },
        {
          key: 'data.Udef1',
          title: 'Case Package',
          align: 'left',
          minWidth: 110,
          compare: 'origin_data.Udef1',
          slot: 'compareCell'
        },
        {
          key: 'data.Udef2',
          title: 'Brand',
          align: 'left',
          minWidth: 100,
          compare: 'origin_data.Udef2',
          slot: 'compareCell'
        },
        {
          key: 'data.Udef3',
          title: 'MSL',
          align: 'left',
          minWidth: 100,
          compare: 'origin_data.Udef3',
          slot: 'compareCell'
        },
        {
          key: 'data.PriceOfTax',
          title: 'Has Tax',
          align: 'center',
          minWidth: 80,
          compare: 'origin_data.PriceOfTax',
          slot: 'booleanCompareCell'
        },
        {
          key: 'data.BusiTaxRate',
          title: 'Tax Rate (%)',
          align: 'right',
          minWidth: 100,
          compare: 'origin_data.BusiTaxRate',
          slot: 'rateCompareCell'
        },
        {
          key: 'data.PerDays',
          title: 'Purchase Days',
          align: 'right',
          minWidth: 110,
          compare: 'origin_data.PerDays',
          slot: 'numberCompareCell'
        },
        {
          key: 'data.MajorSupplier',
          title: 'Major Supplier',
          align: 'left',
          minWidth: 110,
          compare: 'origin_data.MajorSupplier',
          slot: 'compareCell'
        },
        {
          key: 'data.BaseInc',
          title: 'Base Increase',
          align: 'right',
          minWidth: 110,
          compare: 'origin_data.BaseInc',
          slot: 'numberCompareCell'
        },
        {
          key: 'data.MinPurch',
          title: 'MOQ',
          align: 'right',
          minWidth: 100,
          compare: 'origin_data.MinPurch',
          slot: 'numberCompareCell'
        },
        {
          key: 'data.Udef9',
          title: 'MPQ',
          align: 'right',
          minWidth: 100,
          compare: 'origin_data.Udef9',
          slot: 'numberCompareCell'
        },
        {
          key: 'data.CurrID',
          title: 'Currency',
          align: 'left',
          minWidth: 90,
          compare: 'origin_data.CurrID',
          slot: 'compareCell'
        }
      ]
    }
  },
  computed: {
    pageTitle: function () {
      document.title = this.$t('menu.bom.part_migration_history')
      return document.title
    }
  },
  methods: {
    ...mapActions([
      'getTerms',
      'getPartMigrateHistory'
    ]),
    loadPage() {
      this.loading = true
      this.getPartMigrateHistory(this.partId).then(res => {
        this.partMigrateHistory = res.data
        this.loading = false
      })
    }
  },
  mounted() {
    this.loadPage()
  }
}
</script>
